import { render, staticRenderFns } from "./InfluencerMatch_form.vue?vue&type=template&id=d0fa0d1e&scoped=true&"
import script from "./InfluencerMatch_form.vue?vue&type=script&lang=js&"
export * from "./InfluencerMatch_form.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerMatch_form.vue?vue&type=style&index=0&id=d0fa0d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fa0d1e",
  null
  
)

export default component.exports